/*
 * File: ContactSection.tsx
 * Author: Austin Robinson
 * Date Created: 12/07/2025
 * Copyright (c) DrivingDoc 2025
 */
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

interface ContactSectionProps {
  /**
   * The label for this contact section (e.g., "Student", "John Doe (Parent)")
   */
  label: string;

  /**
   * Child ContactItem components
   */
  children: ReactNode;
}

/**
 * A section grouping contact information for a single person
 */
export default function ContactSection({ label, children }: ContactSectionProps) {
  return (
    <Box>
      <Typography variant="body2" fontWeight="600" color="text.primary" mb={0.75}>
        {label}
      </Typography>
      <Stack gap={0.5} pl={0.5}>
        {children}
      </Stack>
    </Box>
  );
}
